import {
    ROUTES_INVITATION_FOR_MEMBERSHIP,
    ROUTES_INVITATION_FOR_MEMBERSHIP_ACCEPT,
    ROUTES_INVITATION_FOR_MEMBERSHIP_REJECT
} from '@/constants/routes';

export default {
    name: ROUTES_INVITATION_FOR_MEMBERSHIP,
    component: () => import(/*webpackChunkName: 'invitation'*/ '@/views/Invitation.vue'),
    path: '/invitation-for-membership',
    children: [
        {
            name: ROUTES_INVITATION_FOR_MEMBERSHIP_ACCEPT,
            path: 'accept',
            component: () => import(/*webpackChunkName: 'invitation'*/ '@/components/invitation/InvitationAccept.vue')
        },
        {
            name: ROUTES_INVITATION_FOR_MEMBERSHIP_REJECT,
            path: 'reject',
            component: () => import(/*webpackChunkName: 'invitation'*/ '@/components/invitation/InvitationReject.vue')
        }
    ]
};
